<script>
	// From Lucide
	import { ListVideo } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ListVideo class={iconClass} />
